import React from 'react';
import { Countdown } from './Countdown';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
export function FinalClose() {
  return <section className="py-16 bg-[#FBF6EC] border-t-8 border-amber-500" data-id="element-51">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-52">
        <h2 className="text-4xl font-black text-rose-900 mb-6" data-id="element-53">
          📚 LENGUA PACK
        </h2>

        <p className="text-2xl text-stone-700 font-medium mb-2" data-id="element-54">
          El próximo domingo podés seguir buscando textos en Google.
        </p>
        <p className="text-2xl text-stone-900 font-black mb-10" data-id="element-55">
          O podés tener todo resuelto desde hoy.
        </p>

        <div className="mb-10" data-id="element-56">
          <Countdown data-id="element-57" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-58">
          <div className="bg-white p-6 rounded-2xl border border-rose-200" data-id="element-59">
            <div className="text-rose-800 font-black text-xl mb-2" data-id="element-60">
              📘 PRIMARIA
            </div>
            <div className="text-2xl font-bold text-stone-900 mb-4" data-id="element-61">
              $16.990 ARS
            </div>
            <a href="https://docente360.com.ar/checkouts/cn/hWNDzskq4E3Xc4yoZbJuElO6/en-ar?_r=AQABi40EEbZd0G4I3u9_6z7X4OnkfgJU7OYT3kZyHXPBols" className="block w-full bg-rose-800 hover:bg-rose-900 text-white font-bold py-3 rounded-xl" data-id="element-62">
              → QUIERO PRIMARIA
            </a>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-emerald-200" data-id="element-63">
            <div className="text-emerald-800 font-black text-xl mb-2" data-id="element-64">
              📗 SECUNDARIA
            </div>
            <div className="text-2xl font-bold text-stone-900 mb-4" data-id="element-65">
              $18.990 ARS
            </div>
            <a href="https://docente360.com.ar/checkouts/cn/hWNDzsl0aezYC88x9xCZMRt4/en-ar?_r=AQAB6STlZGKIFCIoF7xN5vIRIalZWjm0KyqSrPhlXHppvoU" className="block w-full bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 rounded-xl" data-id="element-66">
              → QUIERO SECUNDARIA
            </a>
          </div>
        </div>

        <div className="bg-amber-50 p-8 rounded-2xl border-2 border-amber-500 mb-10" data-id="element-67">
          <div className="text-amber-700 font-black text-2xl mb-2" data-id="element-68">
            🏆 PACK COMPLETO ⭐
          </div>
          <div className="text-4xl font-black text-stone-900 mb-6" data-id="element-69">
            $27.990 ARS
          </div>
          <a href="https://docente360.com.ar/checkouts/cn/hWNDzslAQqun3ygcqhnFzQGI/en-ar?_r=AQABh0VxrhdJq5wOQecSICZV60B-M1ywPMl-hj8z1CZw09s_" className="block w-full bg-amber-500 hover:bg-amber-600 text-white text-xl font-black py-4 rounded-xl shadow-lg" data-id="element-70">
            → QUIERO MI LENGUA PACK COMPLETO
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-stone-500 mb-16" data-id="element-71">
          <div className="flex items-center gap-2" data-id="element-72">
            <Lock className="w-4 h-4" data-id="element-73" /> 🔒 Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-74">
            <Zap className="w-4 h-4" data-id="element-75" /> ⚡ Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-76">
            <Shield className="w-4 h-4" data-id="element-77" /> 🛡️ Garantía 7 días sin preguntas
          </div>
          <div className="flex items-center gap-2" data-id="element-78">
            <CreditCard className="w-4 h-4" data-id="element-79" /> 💳 Mercado Pago | Tarjeta de
            crédito
          </div>
        </div>

        <div className="pt-12 border-t border-stone-200" data-id="element-80">
          <h3 className="text-2xl font-black text-stone-900 mb-4" data-id="element-81">
            📚 LENGUA PACK
          </h3>
          <p className="text-stone-600 font-medium mb-2" data-id="element-82">
            El sistema de planificación N°1 para docentes de Lengua de primaria
            y secundaria en Argentina.
          </p>
          <p className="text-stone-900 font-bold mb-8" data-id="element-83">
            Porque enseñar Lengua no debería costarte todos los domingos del
            año.
          </p>
          <p className="text-sm text-stone-400" data-id="element-84">
            © LENGUA PACK — Profe Listo
            <br data-id="element-85" />
            Todos los derechos reservados
          </p>
        </div>
      </div>
    </section>;
}